<template>
    <div class="create-note">
            <field-text v-model="form.note"
                        :maxlength="2000"
                        class="mb-0"
                        :display-remaining-characters="false"
                        placeholder="Leave your comments here...."
                        :with-placeholder="true">
            </field-text>

            <button class="btn btn-sm btn-success btn-save" @click="save()" :disabled="form.isSubmitted">
                <span v-if="!form.isSubmitted">Save</span>
                <span v-else><i class="fa fa-spin fa-spinner"></i> Saving...</span>
            </button>
    </div>
</template>
<script>
    export default {

        props: {
            model: {
                type: Object,
                required: true,
            },
            url: {
                type: String,
                required: true,
            }
        },

        data() {
            return {
                form: new Form({
                    note: '',
                })
            }
        },

        methods: {
            save() {
                this.form.post(this.url).then(response => {
                    Toast.success('Note created!');
                    this.closeModal('create-note-modal')
                    this.$emit('success', response)
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            }
        },
    }
</script>
